import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Paper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAssociationProducts } from "../../store/actions/products";
import { ASbutton } from "../buttons/ASbutton";
import { styles } from "../../styles/styles";
import { useFormik } from "formik";
import { MdNotificationImportant } from "react-icons/md";

const B2bPlans = ({
  handleNext,
  handleBack,
  selectedPlan,
  setSelectedPlan,
  apportionmentPrice,
  setApportionmentPrice,
  associationId,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.products);
  const [productsFromDB, setProductsFromDB] = useState([]);
  const [loading, setloading] = useState(false);
  const isFirstUse = useRef(true);
  const [noDataAvailable, setNoDataAvailable] = useState(false);

  const getProductsFromFB = useCallback(() => {
    try {
      dispatch(getAssociationProducts(associationId));
    } catch (error) {
      console.log(error);
    }
    // console.log(products);
  }, [products]);

  const dummyPlans = [
    { id: 1, subTier: "Basic Plan", code: "BASIC123", price: 10.99 },
    { id: 2, subTier: "Standard Plan", code: "STANDARD456", price: 19.99 },
    { id: 3, subTier: "Premium Plan", code: "PREMIUM789", price: 29.99 },
    { id: 4, subTier: "Premium Plan", code: "PREMIUM789", price: 29.99 },
    { id: 5, subTier: "Premium Plan", code: "PREMIUM789", price: 29.99 },
    { id: 6, subTier: "Premium Plan", code: "PREMIUM789", price: 29.99 },
    { id: 7, subTier: "Premium Plan", code: "PREMIUM789", price: 29.99 },
    { id: 8, subTier: "Premium Plan", code: "PREMIUM789", price: 29.99 },
    { id: 9, subTier: "Premium Plan", code: "PREMIUM789", price: 29.99 },
    { id: 10, subTier: "Premium Plan", code: "PREMIUM789", price: 29.99 },

    // ... add more dummy plans
  ];

  const duration = [
    {
      value: 12,
      label: "12 meses",
    },
    {
      value: 6,
      label: "6 meses",
    },
    {
      value: 3,
      label: "3 meses",
    },
  ];

  useEffect(() => {
    if (isFirstUse.current) {
      setloading(true);
      getProductsFromFB();
      isFirstUse.current = false;
    } else if (products?.length > 0) {
      setloading(false);
      setProductsFromDB(products);
    } else {
      const timeout = setTimeout(() => {
        setNoDataAvailable(true);
      }, 4200);

      return () => clearTimeout(timeout);
    }
    if (noDataAvailable) {
      setloading(false);
    }
  }, [getProductsFromFB, productsFromDB]);

  const [priceNoIVA, setPriceNoIva] = useState(0);
  const [priceToCharge, setPriceToCharge] = useState(0);

  useEffect(() => {
    const overallDate = new Date();
    const year = overallDate.getFullYear();
    const month = overallDate.getMonth() + 1;
    const date = overallDate.getDate();

    //Days in the month
    const apportionmentDays = new Date(year, month, 0).getDate();
    //Days left in the month
    const apportionment = apportionmentDays - date + 1;
    //SET Price without IVA
    setPriceNoIva(selectedPlan.finalPrice - selectedPlan.finalPrice * 0.13);

    setApportionmentPrice((priceNoIVA / apportionmentDays) * apportionment);

    setPriceToCharge(
      (apportionmentPrice + apportionmentPrice * 0.13).toFixed(2)
    );
  }, [apportionmentPrice, selectedPlan, priceNoIVA]);

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan.id === selectedPlan ? null : plan);
  };

  const formik = useFormik({
    initialValues: {
      planDuration: 0,
      price: selectedPlan.price,
      apportionmentPrice: 0,
    },

    onSubmit: (values) => {
      try {
        const dataToAdd = {
          planSelected: selectedPlan,
          planDuration: values.planDuration,

          price: selectedPlan.price,

          billNumber: values.billNumber,
          apportionmentPrice: apportionmentPrice,
        };

        handleNext(dataToAdd);
      } catch (error) {
        console.log(error);
      }
    },
  });

  const renderCard = (plan, index) => (
    <Grid item xs={10} sm={6} md={5} lg={3.3} key={index}>
      <Paper
        elevation={selectedPlan.id === plan.id ? 5 : 2} // Add elevated effect for selected card
        style={{
          padding: "16px",
          backgroundColor: selectedPlan.id === plan.id ? "#FAFAFB" : "#F6F6F6", // Change background color for selected card
          cursor: "pointer",
          borderRadius: "18px",
          borderWidth: "1px ",
          border: selectedPlan.id === plan.id ? "solid" : "solid",
          borderColor:
            selectedPlan.id === plan.id ? theme.palette.primary.main : "white",
        }}
        onClick={() => handlePlanSelect(plan)}
      >
        <Typography variant="h6" gutterBottom>
          {plan.subTier}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Código {plan.code}
        </Typography>
      </Paper>
    </Grid>
  );
  const renderGrid = () => {
    if (loading && !noDataAvailable) {
      return (
        <Grid container spacing={2} sx={[styles.planSelectionLoading]}>
          <CircularProgress />
        </Grid>
      );
    }
    if (noDataAvailable) {
      return (
        <Grid container spacing={2} sx={[styles.planSelectionLoading]}>
          <Typography>No Hay productos disponibles</Typography>
        </Grid>
      );
    }

    return (
      <Grid
        container
        spacing={2}
        rowGap={2}
        sx={styles.planSelection}
        justifyContent={
          productsFromDB.length > 2 ? "space-around" : "flex-start"
        }
      >
        {productsFromDB.map((plan) => renderCard(plan))}
      </Grid>
    );
  };

  return (
    <Box sx={styles.plansCard}>
      <Box sx={styles.formTitle} mb={4}>
        <Typography
          variant="h7"
          sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
        >
          Selecciona un plan
        </Typography>
      </Box>
      {renderGrid()}
      <Grid
        container
        mt={3}
        justifyContent={"flex-end"}
        sx={{
          marginRight: 2,
          width: "100%",
          [theme.breakpoints.down("sm")]: {
            width: "90%",
            marginRight: "auto",
            marginLeft: "auto",
          },
        }}
      >
        <Grid item xs={12} sm={12} md={4}>
          {selectedPlan && (
            <FormControl fullWidth>
              <TextField
                fullWidth
                label="Seleccione Duración del Plan"
                id="planDuration"
                name="planDuration"
                select
                value={formik.values.planDuration}
                onChange={(e) =>
                  formik.setFieldValue("planDuration", e.target.value)
                }
                helperText={formik.touched.device && formik.errors.device}
                error={Boolean(formik.errors.device)}
                SelectProps={{
                  MenuProps: {
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                    disableScrollLock: true,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MdNotificationImportant />
                    </InputAdornment>
                  ),
                }}
                variant="standard"
              >
                {duration.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        sx={styles.buttonsContainer}
        justifyContent={"flex-end"}
        direction="row"
      >
        <Grid item>
          <ASbutton
            onClick={handleBack}
            type="submit"
            backgroundColor={"grey"}
            color={"white"}
            buttonText={"Atrás"}
          />
        </Grid>
        <Grid item>
          <Box ml={2}>
            <ASbutton
              onClick={formik.handleSubmit}
              backgroundColor={theme.palette.primary.main}
              color={"white"}
              disabled={formik.values.planDuration === 0 || !selectedPlan}
              buttonText={"Siguiente"}
            >
              Submit
            </ASbutton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default B2bPlans;
